import {useTranslation} from "react-i18next";
import Modal from "../../../common/modal/Modal";
import {useClientLocator} from "../../../client/ApiClientLocator";
import TabNav from "../../../common/tab/TabNav";
import {useDefaultQuery} from "../../../client/useDefaultQuery";
import MessageInfoPanel from "./MessageInfoPanel";
import {MessageTranslKey} from "../MessageTranslKey";

export interface MessageDetailPanelProps {
    messageId: number;
    open: boolean;
    onClose: (updated: boolean) => void;
}

export default function MessageDetailPanel(props: Readonly<MessageDetailPanelProps>) {
    const {messageId, open, onClose} = props;
    const {t} = useTranslation();
    const {isdsMessageClient} = useClientLocator();

    const {data: message} = useDefaultQuery({
        queryKey: ["message", messageId],
        staleTime: 5 * 60 * 1000,
        queryFn: () => isdsMessageClient.findById(messageId),
    });

    const messageInfoTab = {
        label: t(MessageTranslKey.MESSAGE_INFO_TAB),
        content: <>
            {message && <MessageInfoPanel message={message} />}
        </>,
    };

    const tabItems = [messageInfoTab];

    return (
        <Modal
            open={open}
            label={t(MessageTranslKey.ISDS_MESSAGE_OVERVIEW)}
            iconProps={{type: "complex", name: "doc-filled"}}
            onClose={() => onClose(false)}
        >
            <TabNav items={tabItems} />
        </Modal>
    );
}
